import { int } from "@goodgamestudios/math-utilities";

// C2S_START_SLOTMACHINE
export class BanditResultVO {
    public cashWon: number = 0;
    public goldWon: number = 0;
    public slot1Icon: number = 0;
    public slot2Icon: number = 0;
    public slot3Icon: number = 0;

    public parse_SSM(paramObject: any): void {
        this.cashWon = paramObject.cashWon;
        this.goldWon = paramObject.goldWon;
        this.slot1Icon = int(paramObject.slot1Icon);
        this.slot2Icon = int(paramObject.slot2Icon);
        this.slot3Icon = int(paramObject.slot3Icon);
    }

    public toString(): string {
        return ('(cashWon:' + this.cashWon + ' goldWon:' + this.goldWon + ' slot1Icon:' + this.slot1Icon + ' slot2Icon:' + this.slot2Icon + ' slot3Icon:' + this.slot3Icon + ')');
    }
}
